import type { CSSProperties, FC, ReactNode, RefObject } from 'react';
import React from 'react';

import { cnBadge } from './Badge.cn';

import './Badge.css';

export interface BadgeProps {
    /**
     * Ссылка на корневой DOM-элемент компонента
     */
    innerRef?: RefObject<HTMLDivElement>;

    /**
     * Пользовательские стили
     */
    style?: CSSProperties;

    /**
     * Дополнительный класс
     */
    className?: string;

    /**
     * Содержимое, отображаемое внутри значка
     */
    content?: ReactNode;

    /**
     * Цвет заливки блока
     */
    color?: string;

    /**
     * Цвет текста блока
     */
    textColor?: string;

    /**
     * Цвет обводки блока
     */
    outlineColor?: string;
    withGhostButton?: boolean;
    children?: ReactNode;
}

/**
 * @deprecated Используйте `Badge` из `@yandex-int/hr-components/HrBadge`
 */
export const Badge: FC<BadgeProps> = ({
    color,
    textColor,
    outlineColor,
    content,
    children,
    innerRef,
    style,
    className,
    withGhostButton,
    ...props
}) => (
    <div ref={innerRef} {...props} className={cnBadge({ withGhostButton }, [className])}>
        {children}
        <div
            className={cnBadge('Dot', {
                withChildren: Boolean(children),
                withContent: Boolean(content),
            })}
            style={{
                backgroundColor: color,
                color: textColor,
                borderColor: outlineColor,
                ...style,
            }}
        >
            {content}
        </div>
    </div>
);

Badge.displayName = cnBadge();
